import AxiosClient from "../../services/axios.services";

class AuthServices {
  getUsers = (params) =>
    AxiosClient.get(`/api/app/User/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getGroups = () =>
    AxiosClient.get(`/api/app/Group/`, {
      headers: { "Content-Type": "application/json" }
    });
  checkUser = (params) =>
    AxiosClient.get(`/api/app/Existe_Correo/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveUser = (data) =>
    AxiosClient.post('/api/app/User/', data, {
      headers: { "Content-Type": "application/json" },
    });
  editUser = (id, data) =>
    AxiosClient.put(`/api/app/User/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteUser = (id) =>
    AxiosClient.delete(`/api/app/User/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  resetPassword = (data) =>
    AxiosClient.post(`/api/app/admin_reset_password/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new AuthServices();
